import { render, staticRenderFns } from "./LoadDocuments.vue?vue&type=template&id=168b5488&scoped=true"
import script from "./LoadDocuments.vue?vue&type=script&lang=js"
export * from "./LoadDocuments.vue?vue&type=script&lang=js"
import style0 from "./LoadDocuments.vue?vue&type=style&index=0&id=168b5488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b5488",
  null
  
)

export default component.exports